var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[(_vm.optimizerManagerList !== null && _vm.optimizerManagerUpdatePermission)?_c('optimizer-manager-edit-tab-account',{staticClass:"mt-4",attrs:{"data":_vm.optimizerManagerList}}):_vm._e(),(!_vm.optimizerManagerUpdatePermission)?_c('not-permission'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }